import { ForwardedRef, HTMLAttributes, forwardRef } from "react";
import { Direction, HorizontalAlign, VerticalAlign } from "..";
import styles from "./styles.module.scss";

export type FlexContainerProps = HTMLAttributes<HTMLDivElement> & {
  direction?: Direction,
  verticalAlign?: VerticalAlign,
  horizontalAlign?: HorizontalAlign,
  gap?: number | string,

  /**
   * @deprecated Use classes instead.
   */
  width?: number | string,

  /**
   * @deprecated Use classes instead.
   */
  height?: number | string,
  spaceBetween?: boolean,
  wrap?: boolean,
};

export type FlexContainerRef = ForwardedRef<HTMLDivElement>;

const FlexContainer = ({ className, children, direction, gap, height, horizontalAlign, spaceBetween, style, verticalAlign, width, wrap, ...props }: FlexContainerProps, ref: FlexContainerRef) => {
  if (direction === undefined) {
    direction = Direction.Column;
  }

  if (process.env.NODE_ENV === "development" && spaceBetween) {
    if (direction === Direction.Column && verticalAlign !== undefined) {
      console.warn("The \"spaceBetween\" property is set, so the \"verticalAlign\" one is ignored.");
    }
    else if (direction === Direction.Row && horizontalAlign !== undefined) {
      console.warn("The \"spaceBetween\" property is set, so the \"horizontalAlign\" one is ignored.");
    }
  }

  return (
    <div
      ref={ref}
      className={`${styles.flexContainer} ${styles[direction]} ${styles[horizontalAlign ?? HorizontalAlign.Center]} ${styles[verticalAlign ?? VerticalAlign.Middle]} ${spaceBetween ? styles.spaceBetween : ""} ${wrap ? styles.wrap : ""} ${className ?? ""}`}
      style={(gap || width || height) ?
        Object.assign({
          gap: typeof gap === "number" ? `${gap}px` : gap,
          width: typeof width === "number" ? `${width}px` : width,
          height: typeof height === "number" ? `${height}px` : height,
          flexShrink: width ? 0 : undefined,
        }, style) :
        style
      }
      {...props}
    >
      {children}
    </div>
  );
};

export default forwardRef(FlexContainer);